import { BaseRepository } from './BaseRepository';
import { getDatabase, NexxusDatabase } from './NexxusDatabase';
import type { Bulletin } from '@shared/types/Bulletin';

export class BulletinRepository extends BaseRepository<Bulletin> {
  constructor(db?: NexxusDatabase) {
    super((db ?? getDatabase()).bulletins);
  }
  async findByPeriode(tenant_id: string, periode: string): Promise<Bulletin[]> {
    return this.table.where('[tenant_id+periode]').equals([tenant_id, periode]).toArray();
  }
  async findBySalarie(salarie_id: string): Promise<Bulletin[]> {
    return this.table.where('salarie_id').equals(salarie_id).toArray();
  }
}
